import { useState } from 'react';
import { CircularProgressProps } from './ProgressIndicator.types';
import { getCoordinates, getRadians, SegmentCap } from './arc-drawing.utils';
import styles from './ProgressIndicator.module.scss';

export const CircularProgress = ({
  total = 8,
  from = 0,
  to = 0,
  color,
}: CircularProgressProps) => {
  const [id] = useState<string>(() =>
    Math.random().toString().replace(/0?\./, '')
  );

  to = Math.min(Math.max(to, 0), total);
  from = Math.min(Math.max(from, 0), to);

  const paddingInRadians = 0.01;
  const width = 1;
  const permanentPath = Number(to > total / 2);
  const startRadians = getRadians({ step: from, total, paddingInRadians });
  const endRadians = getRadians({ step: to, total, paddingInRadians });
  const { x: x0, y: y0 } = getCoordinates(startRadians);
  const { x: x1, y: y1 } = getCoordinates(endRadians);

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 10 10"
      version="1.1"
      className={styles.isAbsolute}
    >
      {/* The mask hides the center of the circle, making the circle/circle sector below into a thick line */}
      <mask id={id}>
        <circle cx="5" cy="5" r="5" fill="white" />
        <circle cx="5" cy="5" r={5 - width} fill="black" />
      </mask>
      {/* The progress bar itself */}
      <path
        d={`M 5 5 L ${x0} ${y0} A 5 5 0 ${permanentPath} 1 ${x1} ${y1} Z`}
        fill={`var(${color})`}
        mask={`url(#${id})`}
      />
      {/* Draw lines at the ends of segments */}
      <SegmentCap radians={startRadians + paddingInRadians} width={width} />
      <SegmentCap radians={endRadians - paddingInRadians} width={width} />
    </svg>
  );
};
